import { SpreadGroup } from 'editor/src/store/design/types';

const getSpreadGroup = (spreadIndex: number, spreadGroups?: SpreadGroup[]) =>
  spreadGroups?.find((group) => group.spreadIndexes.includes(spreadIndex));

export default getSpreadGroup;
